export default "__VITE_PUBLIC_ASSET__8584c54c__"